import AdminHeader from "@/components/common/AdminHeader";
import ReferralList from "@/components/offers/ReferralList";
import PermissionGuard from "@/components/common/PermissionGuard";
import OfferList from "@/components/offers/Offers";

export default function OffersPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <PermissionGuard screen="offers">
          <OfferList />
        </PermissionGuard>
      </main>
    </div>
  );
}